<template>
  <div v-if="params.value !== undefined" class="ag-table-cell-value-wrapper">
    <div class="ag-table-cell-value ag-table-debtors-file-renderer">
      <template v-if="params.data.file">
        <div class="ag-table-debtors-file-renderer__name">{{params.data.file.name}}</div>
        <a :href="params.data.file.path | imgPath" target="_blank"
           class="link-icon ag-table-debtors-file-renderer__icon">
          <app-icon name="DownloadFile" size="20px"/>
        </a>
      </template>
      <span v-else>-</span>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';

  export default Vue.extend({
    name: "FileRenderer",
    computed: {}
  });
</script>

<style lang="scss">
  .ag-table-debtors-file-renderer{

    &__name{
      line-height: 1.1;
    }

    &__icon{
      margin-left: 15px;
    }

  }
</style>
